
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
import swal from 'sweetalert';

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import VueRouter from 'vue-router'
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'

var moment = require('moment-timezone')
import AgoraRTC from "agora-rtc-sdk-ng"
import Vue from 'vue';
window.AgoraRTC = AgoraRTC;
window.moment = moment;
AgoraRTC.setLogLevel(4);
window.Vue = require('vue');
Vue.use(CxltToastr, {
  position: 'top right',
  icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABsNJREFUaEPNWmtsVFUQ/ubublsolALLGwO0u+W1bTGAgJGIxEC3xAQfEREI/BGNIJoAakz8I0RIeAgYDQYTDQgE/SHBtFsMpDGaUN50W6HdbqGoBZEWSlug3d17xpy7tGzb3b13HwXOn03unTvzfWdmzpk5ZwlJGGOLKodbTGKuUGmGovAEMLKIaLBg9JPqFUIrMzeCcFkIqlIUKvMLlNYtcPybqHmKV8GEY5cGq/7AEgaWETAtPj18Gkz7TCnmA1UvTmyMR0fMBGzF5aMJyjoQ3gLQNx6j3b9hxl1SeA/5xVbPS1PqY9FpmMDUM2cszQ2p77LgjUSkhUYvjHsEbBGctslbaG83ot8QgfGu8vGqoEOkUL4RpYnKMIkLZpUXVS2Y4tHTpUvAXlL5KgvxfS/OeliMDG5RQMs9ztyfo5GISsDucq9gpj1EMOvNRC+9V0FYXVOQuzuS/ogE7C732wBF/LCXAIdXy1hTU5j7ZbiXYQnIsAHzIQCmRwo0sjGVmF/zFOYd7i7Sg0B2SaVNYXEWoIwnBLwGg5lbFROme+bnVYXi6kJg0o+VKb50cSrcavNJzlAsHWuFQrp5r8tbMGNvXQM2e/7Tle0qwOczhvhmnJ02zd/xvAsam8v9MYE2hdN6ad4kmBQlRoPhxYUQuHanBXNP/h27Psb6msLcrT0I5PxyYZQwmaqJkB5Oa/X8yaBkzL4QuHvvHnyqilknYicgQ8mimHMuFUy6LnF2esBeXLEDhPcjTUkyCMiZl+Dlb4AZS6vu9DDnVwWutd5FQHBE7zBou9fpWNtJ4EFh9le02iZRAqHgpWGVgc8ipEDDvTacuh45P2TtZE4xj5EFoOYBu6tiDYCd0QIyEQLdwesRUJlx9HL08CKi1Z4Cx1caAZur4rReSRwvgXDgdQkIgaNX/oma4CxwyrsgdwZNLLk4IiAC9XoZGkqgxa/inTNXUd3chrUThmPxmEGasU/d9Si61gTnyAHYmDcaLAT21d7ArtpbyEq3YPvkocgwB1eyaCGkGiAgN4ZACo0ge4n7TTDt11vPQgnsv9qogZUj3azA7XTA09wG528Pi8cjs7Mxxsx47vc6tASEJvuhbRAWjwrujwkTkCsQ4w3KLqrYqSiQORB1hBI40dCKJScua/J5mX1xeLYNt30qnj9ehdaAqpEqnvkUMkyE5eevw90cLO135w3HjIFpSSMA4h1kd7mPAjQvFgJS9o+brfC0tGHh6EwMSgkWqzUtbSi90Yzp/c3I6hN81uRXUXTjLsalW/DswD6dZpLhASZykc1VUUtAVqwEwslHSthwsskgAGYv2YrdjUQUzMIoQ28VigV8snKAgQayudztBEpJhECs4JNFAOD2hAnEAz65BBIIoXjBSwIBBjZEqBYM7QOyR5AhZHe5vQBl64VQ2ZwcDEp7GGmJgJe26vzAd7fCWzVKQEtio8voyDQL1tqsSDebYO+XikyoWlXZMa74AW+b3jQE38tupPw+0Bah4DRKQFtGjW5kodBWjMrAqjGZnY+8PuBgUzAskjGMEniwkVUuBvhALIZDCZQ1taHofioUJfFWswNDu6rieJ3+CSMTFtG4YxXDzD6+rlfMhfOABL+uugHWvn0wyToQliS0nD5V4GLDba2piTo6ijkpZHe5TwE03agXpAemDkjTwLerD/PA6PfWPmmYOtzapceubmxCbVOzURVSrqzGmTsr2NAUV7wHwi6jX+dnpKKq1Yf2KG2fnq7uJGIlwKBVXqfja42AbCkDvsDVSA29Hph434eSiIVAj5ZS80KJ+wswfRAvmHi/s/ZNw9RhVnhvNxsOIWZs8xbmrpM2O5cOvWOVeAEa+U6S6J9iwZWmFl1xeWodEEpOx/VU14OtYvdHRLRZV0svCMgTP3lipzeIsM5TkLutQ64LAe0W5mbKSYCe1lP0WN4zzmUMbZ8Z8WhRgnqSD3dNxNOqnfnVoZMXdvvMcVW8zMBPT9LxOoNe8TodR7p7PvIFR7F7JYi+eSyhEmqUmUlRVnoKHN+Gw/LkXzGBV9U48yJOpG4FllPsXigIewnU/9F6g5sZyrJwYaObA92BZv160W5SA4ce2erEOCcUWlRb4PDqTZquBzoUzCktNde3W1cx84Ze9IZ20W1uoc8vvu7w6YHvshMbEZYy8ixV5cB6wbQyWbWTrG3kghEQ2BLrH0AMe6A7QVkAioB/sQCWksAzsfQTmi5mBtFJIvrBAhz8s8ARoUOOPrVxEwhVm320fKhJVV5ghWcSY4LKNI7AQ0DBv9uA0cqgmybiK0yoIkFlqkmU1s7Pj/WWrweb/wHv523N1a9mMgAAAABJRU5ErkJggg==',
  closeButton: true,
  timeOut: 10000,
})

window.swal = swal
// Initialize Firebase

// var firebaseConfig = {
//   apiKey: "AIzaSyA64UMf5aG0eJZL4-fg0emyrWYPwLn3wk0",
//   authDomain: "jpal-b0b71.firebaseapp.com",
//   databaseURL: "https://jpal-b0b71.firebaseio.com",
//   projectId: "jpal-b0b71",
//   storageBucket: "jpal-b0b71.appspot.com",
//   messagingSenderId: "273775860251",
//   appId: "1:273775860251:web:3e5a7ddd1aa6b802d1b6be",
//   measurementId: "G-TKYZDXMX1Z"
// };
// var firebaseConfig = { "apiKey": "AIzaSyBJPEASaYt26TNpY8J7pKxJS7b7v25JHCk", "authDomain": "jpal-testing.firebaseapp.com", "databaseURL": "https://jpal-testing.firebaseio.com", "projectId": "jpal-testing", "storageBucket": "jpal-testing.appspot.com", "messagingSenderId": "1069604183868", "appId": "1:1069604183868:web:ac5d57d1b1718170444839", "measurementId": "G-GZW3TJDNYS" };
var firebaseConfig = process.env.MIX_FIREBASE_CONFIG;
console.log(firebaseConfig);
firebase.initializeApp(JSON.parse(firebaseConfig));

window.database = firebase.database();
window.auth = firebase.auth();
const CallPage = require('./pages/Call.vue');
const IncomingCall = require('./pages/IncomingCall.vue');
const Main = require('./pages/Main.vue');
/**
 * Automatically register components.
 */
const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
const routes = [
  { path: '/incoming', component: IncomingCall.default, name: 'incoming' },
  { path: '/call', component: CallPage.default, name: 'call' },
  { path: '/', component: Main.default },
];
Vue.use(VueRouter)

const router = new VueRouter({ routes });
const app = new Vue({
  router,
  history,
}).$mount('#app');
